export default "__VITE_ASSET__e26c9bb8__"